import { render, staticRenderFns } from "./projects.vue?vue&type=template&id=698f99b5&scoped=true&"
import script from "./projects.vue?vue&type=script&lang=ts&"
export * from "./projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f99b5",
  null
  
)

export default component.exports